import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { DELETE_URL } from '@utils/api/endpoints.ts';
import { AxiosError } from 'axios';
import { BaseError } from '@utils/types/shared/base.ts';
import { QueryKeys } from '@utils/api/query-keys.ts';

export function deleteTemplate(id: number): Promise<void> {
  return Axios.delete(DELETE_URL(id.toString()).deleteExportTemplates).then(
    () => {}
  );
}

export function useDeleteExportTemplate() {
  const queryClient = useQueryClient();

  return useMutation<void, AxiosError<BaseError>, number>(deleteTemplate, {
    onSuccess: () => {
      queryClient.invalidateQueries(QueryKeys.exportTemplates());
    },
    useErrorBoundary: false
  });
}
